import XModal from "../common/XModal";
import { HELP_CATEGORIES_MAP } from "@demandproai/shared";
import XSelect from "../common/XSelect";
import XTextarea from "../common/XTextarea";

const HelpRequestModal = ({ isOpen, onClose, formik, isLoading = false, footerAction = null }) => {
  return (
    <XModal
      isOpen={isOpen}
      title="Get Help"
      onClose={onClose}
      onSubmit={formik.handleSubmit}
      submitText="Send Request"
      isSubmitting={isLoading}
      footerAction={footerAction}
      size="sm"
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="add-form p-0">
          <div className="px-4">
            <div className="row pt-3">
              <div className="col-12">
                <div className="form-group">
                  <XSelect
                    name="category"
                    label="Category"
                    options={Object.values(HELP_CATEGORIES_MAP)}
                    {...formik.getFieldProps("category")}
                    error={formik.touched.category && formik.errors.category}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="form-group">
                  <XTextarea
                    name="comment"
                    placeholder="Tell us what you need help with or what we can do to make your ARCHES experience better."
                    label="Comment"
                    {...formik.getFieldProps("comment")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </XModal>
  );
};

export default HelpRequestModal;
